// extracted by mini-css-extract-plugin
export default {"title":"title--mp-iwLLk","slideList":"slideList--mp-DcAHo","wrapper":"wrapper--mp-QdZ29","buttonContainer":"buttonContainer--mp-Jfcn0"};